<div class="ui container fluid">
  <div class="flexed">
    <div class="box">
      <p class="chart-header">Total Highest Upload Size Distribution</p>
      <div class="ui divider" appMargin marginB="3"></div>
      <div
        echarts
        [options]="line"
        style="height: 200px"
        class="demo-chart"
      ></div>
    </div>

    <div class="box">
      <p class="chart-header">Total Access Attempt Request</p>
      <div class="ui divider" appMargin marginB="3"></div>
      <div
        echarts
        [options]="options2"
        style="height: 200px"
        class="demo-chart"
      ></div>
    </div>
    <div class="box">
      <p class="chart-header">Total File Upload Anomalies Alert</p>
      <div class="ui divider" appMargin marginB="3"></div>
      3
    </div>
    <div class="box">
      <p class="chart-header">Total Request Rates</p>
      <div class="ui divider" appMargin marginB="3"></div>
      4
    </div>
  </div>
</div>
